import React from 'react';

import EmployerPartners from 'Components/EmployerPartners';
import EmployerTeam from 'Components/EmployerTeam';
import Footer from 'Components/Footer';
import Header from 'Components/Header';
import PartnersCategory from 'Components/PartnersCategory';

export default function PartnerPage() {
  return (
    <>
      <Header />
      <PartnersCategory />
      <EmployerPartners bg='bg' overlay='dark' />
      <EmployerTeam />
      <Footer />
    </>
  );
}
